import {AxiosError} from 'axios';

import {
    ChangePasswordDTO,
    Completable,
    completed,
    KashableResponseDTO,
    ParsleyDTO,
    ResetPasswordDTO,
    UsersRegistrationDTO,
} from 'kashable-mobile-common';

import {errored, mapSucceeded} from '../utils/AxiosUtils';

import axios from './base';

export interface UsersLoginDTO {
    username: string;
    password: string;
    recaptcha_key?: string;
}

const login: (c: UsersLoginDTO) => Promise<Completable<boolean>> = (creds) => {
    const params = new URLSearchParams();
    params.append('username', creds.username);
    params.append('password', creds.password);
    params.append('recaptcha_key', creds.recaptcha_key || '');

    const headers = {'X-User-ID': creds.username};

    return axios
        .post<KashableResponseDTO<boolean>>('/login', params, {headers})
        .then(() => completed(true))
        .catch((error: AxiosError<string>) => errored(error));
};

const logout: () => Promise<Completable<boolean>> = () => {
    return axios
        .get<KashableResponseDTO<boolean>>('/logout')
        .then(() => completed(true))
        .catch((error: AxiosError<string>) => errored(error));
};

const register: (r: UsersRegistrationDTO) => Promise<Completable<boolean>> = (reg) => {
    return axios
        .post<KashableResponseDTO<string>>('/pub/user/register', reg)
        .then(() => completed(true))
        .catch((error: AxiosError<string>) => errored(error));
};

const resetPassword: (r: ResetPasswordDTO) => Promise<Completable<boolean>> = (reset) => {
    return axios
        .post<KashableResponseDTO<boolean>>('/pub/user/password', reset)
        .then((res) => completed(res.data.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const changePassword: (r: ChangePasswordDTO) => Promise<Completable<ParsleyDTO>> = (reset) => {
    return axios
        .put<KashableResponseDTO<ParsleyDTO>>('/pub/user/password', reset)
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const verifyUnsecuredBank: (k: string) => Promise<Completable<boolean>> = (key: string) => {
    return axios
        .get<KashableResponseDTO<boolean>>('/pub/bank', {params: {key}})
        .then(() => completed(true))
        .catch((error: AxiosError<string>) => errored(error));
};

const verifyUnsecuredEmail: (k: string) => Promise<Completable<boolean>> = (key: string) => {
    return axios
        .get<KashableResponseDTO<boolean>>('/pub/user/email/verify', {params: {key}})
        .then(() => completed(true))
        .catch((error: AxiosError<string>) => errored(error));
};

const googleAuth: (e: string) => Promise<Completable<boolean>> = (payload) => {
    return axios
        .post<KashableResponseDTO<boolean>>('/oauth/social/google', JSON.parse(payload))
        .then(() => completed(true))
        .catch((error: AxiosError<string>) => errored(error));
};

const facebookAuth: (e: string) => Promise<Completable<boolean>> = (payload) => {
    return axios
        .post<KashableResponseDTO<boolean>>('/oauth/social/facebook', JSON.parse(payload))
        .then(() => completed(true))
        .catch((error: AxiosError<string>) => errored(error));
};

const verifyUnsecuredPasswordResetToken: (e: string) => Promise<Completable<boolean>> = (token) => {
    return axios
        .post<KashableResponseDTO<boolean>>('/pub/user/password/verifyToken', {token})
        .then((res) => completed(res.data.data))
        .catch((error: AxiosError<string>) => errored(error));
};

const subscription: (k: string) => Promise<Completable<string>> = (key: string) => {
    return axios
        .get<string>('/pub/subscription', {params: {key}})
        .then((res) => mapSucceeded(res, (d) => d))
        .catch((error: AxiosError<string>) => errored(error));
};

export {
    login,
    logout,
    register,
    resetPassword,
    changePassword,
    verifyUnsecuredBank,
    verifyUnsecuredEmail,
    verifyUnsecuredPasswordResetToken,
    googleAuth,
    facebookAuth,
    subscription,
};
